module.exports = __webpack_public_path__ + "static/media/facebook_form_image_placeholder.2c42ef11.jpg";